import ParentRelationshipEditor from "./ParentRelationshipEditor.js";
import ParentRelationshipColumnCreator from "./ParentRelationshipColumnCreator.js";
import ParentRelationshipExportFieldCreator from "./ParentRelationshipExportFieldCreator.js";
import ParentRelationshipDetailCreator from "./ParentRelationshipDetailCreator.js";
import ParentRelationshipCustomTextModel from "./ParentRelationshipCustomTextModel.js";
import ParentRelationshipCustomTextRenderer from "./ParentRelationshipCustomTextRenderer.js";
function install(molten) {
  molten.addPlugin('AttributeValueEditor', ParentRelationshipEditor);
  ParentRelationshipColumnCreator.install(molten);
  ParentRelationshipExportFieldCreator.install(molten);
  ParentRelationshipDetailCreator.install(molten);
  molten.addPlugin('Model', {
    type: ParentRelationshipCustomTextModel.TYPE,
    model: ParentRelationshipCustomTextModel
  });
  molten.addPlugin('CustomTextValueRenderer', ParentRelationshipCustomTextRenderer);
}
export default {
  install
};